export default { title: 'Sign up / Log in to view your order history' };
